import React, { useState, useEffect } from 'react';
import '../CSS/mesure.css';
import { fetchAverage, fetchLastPoint } from '../FireBase/firebaseService';
import { ref, update } from "firebase/database";
import db from "../FireBase/firebase"; 

const Mesure = ({  field, x, y, seuilMin, seuilMax, id }) => {
  const [lastPoint, setLastPoint] = useState(null);
  const [position, setPosition] = useState({ x, y });
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const collectionName = localStorage.getItem('collectionName') || '/data';
  const [moyenneMesure, setMoyenneMesure] = useState(0);

  useEffect(() => {
    const unsubscribe = fetchAverage(
      collectionName,
      field,
      (average) => setMoyenneMesure(average),
      (error) => console.error(error)
    );
    return () => unsubscribe();
  }, [collectionName, field]);

  useEffect(() => {
    const unsubscribe = fetchLastPoint(
      collectionName,
      (point) => setLastPoint(point),
      (error) => console.error(error)
    );
    return () => unsubscribe();
  }, [collectionName]);

  // fonction pour mettre a jour la position dans la BD 
  const modifPosition = (x, y) => {
    const pathDB = "parametres/mesures/" + id;
    const paramRef = ref(db, pathDB);
    update(paramRef, { x: x, y: y }).catch((error) => {
      console.error("Erreur lors de la mise à jour de Firebase : ", error);
    });
  };
  

  const handleMouseDown = (e) => {
    document.body.style.userSelect = 'none';
    const rect = e.target.getBoundingClientRect();
    setOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: ((e.clientX - offset.x) / window.innerWidth) * 100,
        y: ((e.clientY - offset.y) / window.innerHeight) * 100,
      });
    }
  };

  const handleMouseUp = () => {
    document.body.style.userSelect = 'auto';
    setIsDragging(false);
    modifPosition(position.x, position.y);
  };

 
  const valeurMesure = lastPoint ? lastPoint[field] : null;
  const containerClass =
    valeurMesure !== null && valeurMesure >= seuilMin && valeurMesure <= seuilMax ? "green" : "red";

  return (
    <div
      className={`mesure-container ${containerClass}`}
      style={{
        left: `${position.x}%`,
        top: `${position.y}%`,
        position: 'absolute',
      }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onMouseDown={handleMouseDown}
    >
      <h3>{id}</h3>
      {lastPoint && <p className="mesure">{valeurMesure}</p>}
      <h3>Moyenne</h3>
      <p>{moyenneMesure.toFixed(2)}</p>
    </div>
  );
}

export default Mesure;
